const plugins = require.context('/', false, /\.js$/);
plugins.keys().forEach((key) => {
  if (key !== './index.js') plugins(key);
});
